(function(){
"use strict";

errorPageController.$inject = ["$scope", "scAnalyticsHelper", "scMembersService", "scAuth"];
function errorPageController($scope, scAnalyticsHelper, scMembersService, scAuth) {
  $scope.SC = SC;

  if ($scope.SC.member) {
    scMembersService.init(SC.member);
    // moved checkStatus(), which was on line 3, inside `if` block to make sure scMemberService is available for checkStatus() when it is called.
    // *************************************
    // GFM Jira AI-4803 - GoogleTagManger creates a iframe at runtime, with invalid src url, which returns error page.
    // For any existing IDP sessions in browser, checkStatus() method depends on scMemberService to decide if needs to attempt stealthLogin().
    // stealthLogin initiates Okta /authorize call by redirecting browser
    // Earlier when checkStatus was called without intializing scMemberService, FRS error page use to get stuck in a loop by calling stealthLogin() again and again.
    scAuth.checkStatus();
  }

  scAnalyticsHelper.setup($scope);

  switch ($scope.SC.statusCode) {
    case 500:
      $scope.errorMessage = {
        header: "We're currently experiencing technical difficulties.",
        subHeader: "You can always reach out to the Care Team at <a href='https://support.classy.org/s/contactcare' target='_blank' rel='noreferrer noopener'>support.classy.org/s/contactcare</a>."
      };
      break;

    case 403:
      $scope.errorMessage = {
        header: "You don't have access to this page.",
        subHeader: 'Please contact your admin to request access or learn more about permissions&nbsp;<a href="https://support.classy.org/s/article/roles-and-permissions" target="_blank" rel="noreferrer noopener">here</a>.'
      };
      break;

    default:
      $scope.errorMessage = {
        header: "We can't seem to find that page.",
        subHeader: 'You can reach out to the Care Team at <a href="https://support.classy.org/s/contactcare" target="_blank" rel="noreferrer noopener">support.classy.org/s/contactcare</a>.'
      };
      break;
  }
}

angular.module('classy.errors').controller('errorPageController', errorPageController);
})();